import { render, staticRenderFns } from "./InstitutionsPersonList.vue?vue&type=template&id=2c323819&scoped=true&"
import script from "./InstitutionsPersonList.vue?vue&type=script&lang=js&"
export * from "./InstitutionsPersonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c323819",
  null
  
)

export default component.exports